import { apiPaths } from 'api/kinerja/kepala-sekolah/config'
import { useKinerjaApi } from 'api/kinerja/utils/api'

import type { CommonListResponse, CommonResponse } from 'types/api'
import type { PenilaianSchool, Schools } from 'types/kinerja-ks'
import type { UseQueryOptions } from 'react-query'

export const API_GET_SCHOOLS_QUERY_KEY = 'API_GET_SCHOOLS_QUERY_KEY'

export function useApiGetSchoolList(
  opts?: UseQueryOptions<CommonResponse<Schools>>
) {
  return useKinerjaApi<CommonResponse<Schools>>(`${apiPaths.kinerja}/schools`, {
    queryKey: API_GET_SCHOOLS_QUERY_KEY,
    queryConfig: {
      enabled: false,
      useErrorBoundary: false,
      ...opts,
    },
  })
}

export function useApiGetPenilaianSchoolList({
  options,
}: {
  options?: UseQueryOptions<CommonListResponse<PenilaianSchool>>
}) {
  return useKinerjaApi<CommonListResponse<PenilaianSchool>>(
    `${apiPaths.basePath}/v1/penilaian/schools`,
    {
      queryConfig: {
        ...options,
      },
    }
  )
}
